import { createStructuredSelector } from 'reselect';
import { getFormValues } from 'redux-form/immutable';
import { userDataSelector, assessmentServiceSelector } from '@selectors/global';
import {
  propertyLookupModalOpenSelector,
  propertyLookupModalModeSelector,
  propertyLookupMarketLookupModeSelector,
  propertyLookupCurrentValuationModeSelector,
  propertyLookupModalSearchParamsSelector,
  propertyLookupModalPrimarySearchFieldsSelector,
  propertyLookupModalPrimaryResultFieldsSelector,
  propertyLookupModalStateSelector,
  propertyLookupModalDataSelector,
  propertyLookupModalRecordCountSelector,
  searchResultsConfigSelector,
  searchConfigSelector,
  propertyDropdownsSelector,
  propertyLookupModalFutureYearSelector,
  propertyLookupModalAddPropertyToSGSelector,
  propertyLookupModalAddPropertyToBPSelector,
  getMarketApproachData,
} from '../../selectors/property';
import {
  preferenceSelector,
  currentAppraisalYearSelector,
  appraisalYearsSelector,
} from '../../selectors/global';

export default createStructuredSelector({
  addPropertyToBP: propertyLookupModalAddPropertyToBPSelector,
  addPropertyToSG: propertyLookupModalAddPropertyToSGSelector,
  futureYear: propertyLookupModalFutureYearSelector,
  assessmentService: assessmentServiceSelector,
  modalOpen: propertyLookupModalOpenSelector,
  mode: propertyLookupModalModeSelector,
  marketLookup: propertyLookupMarketLookupModeSelector,
  currentValuation: propertyLookupCurrentValuationModeSelector,
  marketApproach: getMarketApproachData,
  searchParams: propertyLookupModalSearchParamsSelector,
  primarySearchFields: propertyLookupModalPrimarySearchFieldsSelector,
  primaryResultFields: propertyLookupModalPrimaryResultFieldsSelector,
  state: propertyLookupModalStateSelector,
  data: propertyLookupModalDataSelector,
  config: searchConfigSelector,
  preference: preferenceSelector,
  recordCount: propertyLookupModalRecordCountSelector,
  columns: searchResultsConfigSelector,
  userData: userDataSelector,
  appraisalYears: appraisalYearsSelector,
  currentAppraisalYear: currentAppraisalYearSelector,
  dropdowns: propertyDropdownsSelector,
  values: state => getFormValues('propertyLookupSearch')(state),
});
